const Const = {
    RETURNS_TABLE_FETCH_RETURNS: 'RETURNS_TABLE_FETCH_RETURNS',
    RETURNS_TABLE_CHANGE_ORDER_FILTER: 'RETURNS_TABLE_CHANGE_ORDER_FILTER',
    RETURNS_TABLE_FETCH_REQUEST_START: 'RETURNS_TABLE_FETCH_REQUEST_START',
    RETURNS_TABLE_CHANGE_TABLE_CURRENT_PAGE: 'RETURNS_TABLE_CHANGE_TABLE_CURRENT_PAGE',
    RETURNS_TABLE_CHANGE_FILTERS_BY_INBOUND_METRICS: 'RETURNS_TABLE_CHANGE_FILTERS_BY_INBOUND_METRICS',
};

export default Const;